var SliderViewModel,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

SliderViewModel = (function() {
  function SliderViewModel(options) {
    this.trackClick = bind(this.trackClick, this);
    this.dragHandler = bind(this.dragHandler, this);
    this.dragStopHandler = bind(this.dragStopHandler, this);
    this.dragStartHandler = bind(this.dragStartHandler, this);
    this.getFillRightValue = bind(this.getFillRightValue, this);
    this.getTickMarginPercentage = bind(this.getTickMarginPercentage, this);
    this.getCommitedValueStyles = bind(this.getCommitedValueStyles, this);
    this.getOutOfRangeValueLeftPosition = bind(this.getOutOfRangeValueLeftPosition, this);
    this.convertToNumber = bind(this.convertToNumber, this);
    this.getValuePercentage = bind(this.getValuePercentage, this);
    this.getMaxFromValidationRule = bind(this.getMaxFromValidationRule, this);
    this.getMinFromValidationRule = bind(this.getMinFromValidationRule, this);
    this.validateValueAganistMinAndMaxBound = bind(this.validateValueAganistMinAndMaxBound, this);
    this.validateValue = bind(this.validateValue, this);
    options = options || {};
    this.minDefault = 1;
    this.maxDefault = 128;
    this.step = 1;
    this.hasjQueryUi = libraries.jqueryUi;
    this.value = ko.asObservable(options.value != null ? options.value : this.minDefault);
    this.min = ko.asObservable(options.min != null ? options.min : this.getMinFromValidationRule());
    this.max = ko.asObservable(options.max != null ? options.max : this.getMaxFromValidationRule());
    this.disabled = ko.asObservable(options.disabled != null ? options.disabled : false);
    this.value.subscribe((function(_this) {
      return function(newValue) {
        newValue = Math.floor(_this.convertToNumber(newValue, _this.min()));
        if (_this.value() !== newValue) {
          _this.value(newValue);
        }
        _this.validateValue();
        _this.possibleValue(_this.value());
      };
    })(this));
    this.possibleValue = ko.observable(this.value());
    this.shouldShowTicks = ko.asObservable(options.showTicks != null ? options.showTicks : true);
    this.validateValue();
    this.minBound = ko.asObservable(options.minBound != null ? options.minBound : this.min);
    this.maxBound = ko.asObservable(options.maxBound != null ? options.maxBound : this.max);
    this.minBound.subscribe(this.validateValueAganistMinAndMaxBound);
    this.maxBound.subscribe(this.validateValueAganistMinAndMaxBound);
    this.validateValueAganistMinAndMaxBound();
    this.numberofTotalSteps = ko.pureComputed((function(_this) {
      return function() {
        return _this.maxBound() - _this.minBound();
      };
    })(this));
    this.boundedSingleStepPercentage = ko.pureComputed((function(_this) {
      return function() {
        return 100 / _this.numberofTotalSteps();
      };
    })(this));
    this.currentValuePercentage = ko.pureComputed((function(_this) {
      return function() {
        return (_this.value() - _this.min()) * 100 / (_this.max() - _this.min());
      };
    })(this));
    this.validTrackLeftMargin = ko.pureComputed((function(_this) {
      return function() {
        return (Math.abs(_this.minBound() - _this.min()) * _this.boundedSingleStepPercentage()) + "%";
      };
    })(this));
    this.validTrackRightMargin = ko.pureComputed((function(_this) {
      return function() {
        return (Math.abs(_this.max() - _this.maxBound()) * _this.boundedSingleStepPercentage()) + "%";
      };
    })(this));
    this.canShowTicks = ko.pureComputed((function(_this) {
      return function() {
        if (_this.numberofTotalSteps() > 32) {
          return false;
        } else {
          return _this.shouldShowTicks();
        }
      };
    })(this));
    this.fillRightValue = ko.pureComputed((function(_this) {
      return function() {
        return (100 - _this.getValuePercentage(_this.value())) + "%";
      };
    })(this));
    this.mainClasses = ko.pureComputed((function(_this) {
      return function() {
        var classes;
        classes = [];
        if (_this.max() < _this.maxBound()) {
          classes.push('has-max-bound');
        }
        if (_this.min() > _this.minBound()) {
          classes.push('has-min-bound');
        }
        if (_this.disabled()) {
          classes.push('disabled');
        }
        return classes.join(' ');
      };
    })(this));
    this.isCommitedValueOutSideRange = ko.pureComputed((function(_this) {
      return function() {
        if (_this.value.isTrackableObservable) {
          return _this.value.committedValue() > _this.max() || _this.value.committedValue() < _this.min();
        }
        return false;
      };
    })(this));
    this.outOfRangeMessage = ko.pureComputed((function(_this) {
      return function() {
        if (_this.value.isTrackableObservable && _this.isCommitedValueOutSideRange()) {
          return "The current value of <strong>" + (_this.value.committedValue()) + "</strong> is outside the valid range of <strong>" + (_this.min()) + " &ndash; " + (_this.max()) + "</strong>. The closest allowable value has been selected.";
        }
      };
    })(this));
  }

  SliderViewModel.prototype.validateValue = function() {
    if (this.value() < this.min()) {
      console.error('value cannot be less than the minimum value.');
      this.value(this.min());
    }
    if (this.value() > this.max()) {
      console.error('value cannot be greater than the maximum value');
      this.value(this.max());
    }
  };

  SliderViewModel.prototype.validateValueAganistMinAndMaxBound = function() {
    if (this.value() < this.minBound()) {
      console.error('value cannot be less than the min bound value.');
      this.value(this.minBound());
    }
    if (this.value() > this.maxBound()) {
      console.error('value cannot be greater than the max bound value');
      this.value(this.maxBound());
    }
  };

  SliderViewModel.prototype.getMinFromValidationRule = function() {
    var minValue, rules;
    rules = this.value.rules ? this.value.rules().filter((function(r) {
      return r.rule === 'min';
    })) : [];
    minValue = rules.length > 0 ? rules[0].params : void 0;
    if (ko.isObservable(minValue)) {
      return minValue;
    }
    return this.convertToNumber(minValue, this.minDefault);
  };

  SliderViewModel.prototype.getMaxFromValidationRule = function() {
    var maxValue, rules;
    rules = this.value.rules ? this.value.rules().filter((function(r) {
      return r.rule === 'max';
    })) : [];
    maxValue = rules.length > 0 ? rules[0].params : void 0;
    if (ko.isObservable(maxValue)) {
      return maxValue;
    }
    return this.convertToNumber(maxValue, this.maxDefault);
  };

  SliderViewModel.prototype.getValuePercentage = function(newValue) {
    return (newValue - this.min()) * 100 / (this.max() - this.min());
  };

  SliderViewModel.prototype.convertToNumber = function(value, defaultValue) {
    var result;
    result = defaultValue;
    if (typeof value === 'string') {
      result = parseFloat(value);
    } else if (!isNaN(parseFloat(value)) && isFinite(value)) {
      result = value;
    }
    return result;
  };

  SliderViewModel.prototype.getOutOfRangeValueLeftPosition = function() {
    return ((this.value.committedValue() - this.minBound()) * 100 / (this.maxBound() - this.minBound())) + "%";
  };

  SliderViewModel.prototype.getCommitedValueStyles = function() {
    var leftPosition;
    leftPosition = (this.value.committedValue() - this.minBound()) * 100 / (this.maxBound() - this.minBound());
    if (leftPosition > 100) {
      return {
        display: 'none'
      };
    } else {
      return {
        display: 'block',
        left: leftPosition + "%"
      };
    }
  };

  SliderViewModel.prototype.getTickMarginPercentage = function(index) {
    return ((index() + 1) * this.boundedSingleStepPercentage()) + "%";
  };

  SliderViewModel.prototype.getFillRightValue = function() {
    return (100 - this.currentValuePercentage()) + "%";
  };

  SliderViewModel.prototype.dragStartHandler = function(event, ui) {
    $(ui.helper).children('.slider-tooltip').fadeIn({
      duration: 50,
      easing: 'easeOutQuad'
    });
  };

  SliderViewModel.prototype.dragStopHandler = function(event, ui) {
    var fill;
    $(ui.helper).children('.slider-tooltip').fadeOut({
      duration: 200,
      easing: 'easeOutQuad'
    });
    $(ui.helper).css({
      left: this.currentValuePercentage() + '%'
    });
    fill = $(ui.helper).siblings('.slider-value-fill');
    fill.css({
      right: this.getFillRightValue()
    });
    this.value(this.possibleValue());
  };

  SliderViewModel.prototype.dragHandler = function(event, ui) {
    var fill, stepWidth, track, validTrack;
    track = $(ui.helper).parents('.slider-track');
    validTrack = $(ui.helper).parent('.slider-valid-track');
    fill = $(ui.helper).siblings('.slider-value-fill');
    stepWidth = track.width() / this.numberofTotalSteps();
    fill.css({
      right: validTrack.width() - ui.position.left
    });
    this.possibleValue(Math.abs(Math.round(ui.position.left / stepWidth) + this.min()));
  };

  SliderViewModel.prototype.trackClick = function(data, event) {
    var element, stepWidth, track;
    if (this.disabled()) {
      return;
    }
    element = $(event.target);
    if (!element.is('.slider-handle2')) {
      track = element.parents('.slider-track');
      stepWidth = track.width() / this.numberofTotalSteps();
      this.possibleValue(Math.abs(Math.round(event.offsetX / stepWidth) + this.min()));
      this.value(this.possibleValue());
    }
  };

  return SliderViewModel;

})();
